import React from 'react'
import { useParams } from 'react-router-dom'
import { useUser } from '@/context/UserProvider'
import { Container, Spinner } from '@/components/__UI'
import { PropertyAmendsEditLayout, PropertyImagery } from '@/components/__PropertyAmendsComponents'
import PromoteOwnerAppBannerWrapper from '@/components/__UI/PromoteOwnerAppBannerWrapper'
import { HeaderSection, InfoSection, TitleLink } from './PropertyAmendsImageryPage.styles'
import PhotographyGuideline from '@/assets/photographyGuides/Owner Photography Guidelines.pdf'
import OrderForm from '@/assets/photographyGuides/Owner Order Form.pdf'
import PropertyGuideline from '@/assets/photographyGuides/Owner propped guidelines.pdf'

const PropertyAmendsImageryPage = () => {
  const { id } = useParams()
  const { user, loading, hasPermission } = useUser()
  const isPermitted = hasPermission('Bookings')

  if (!isPermitted && !loading) {
    return (
      <Container>
        <p style={{ textAlign: 'center' }}>You do not have permission to view this page</p>
      </Container>
    )
  }

  if (!user || loading) {
    return (
      <Container>
        <Spinner />
      </Container>
    )
  }

  return (
    <PropertyAmendsEditLayout propertyId={id}>
      <HeaderSection>
        <h1>Property images</h1>
      </HeaderSection>
      <InfoSection>
        <p><TitleLink data-testid="howToPhotoLink" href='https://fast.wistia.com/embed/medias/19we5oc5zz' target='_blank' rel="noopener noreferrer">How to Photograph My Property Video Guide</TitleLink></p>
        <p>Here are the images that we currently have for your property.</p>
        <p><a data-testid="PhotographyGuidelineLink" href={PhotographyGuideline} target='_blank' rel="noopener noreferrer">Click here</a> to read our photography guidelines. <a href={PropertyGuideline} target='_blank' rel="noopener noreferrer">Click here</a> for hints and tips on how to prepare your property for photographs.</p>
      </InfoSection>
      <PromoteOwnerAppBannerWrapper
        title='Make life easier with the APP'
        description='Uploading and organising your images is faster and more convenient on the app. Take fresh photos, upload from your camera roll, and edit your image gallery in just a few taps.'
        buttonText='Get it here'
      />
      <div>
        <PropertyImagery propertyId={id} data-testid="property-imagery"/>
      </div>
    </PropertyAmendsEditLayout>
  )
}

export default PropertyAmendsImageryPage